import styled from "styled-components";

export const Wrapper = styled.div`
    display: flex;
    padding: 6px;
`;

export const MessageInput = styled.textarea`
    font-size: 16px;
    flex: 1;
    border: 1px solid ${p => p.theme.c.disabled};
    margin-right: 6px;
    height: 40px;
`;

export const Close = styled.div`
    cursor: pointer;
    font-size: 18px;
    line-height: 38px;
    width: 22px;
    height: 18px;
    text-align: center;
    color: ${p => p.theme.c.disabled};
`;
